"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var CanvasFactory = /*#__PURE__*/function () {
  function CanvasFactory() {
    (0, _classCallCheck2["default"])(this, CanvasFactory);
  }

  (0, _createClass2["default"])(CanvasFactory, [{
    key: "getCanvas",

    /**
     * getCanvas is a required method for CanvasFactory
     *
     * @param {object} options
     */
    value: function getCanvas() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      // eslint-disable-line no-unused-vars
      throw new Error('Subclass should implement getCanvas');
    }
    /**
     * Checks if object is an instance of CanvasFactory
     *
     * @param inputObject
     * @returns {boolean}
     */

  }], [{
    key: "isCanvasFactory",
    value: function isCanvasFactory(inputObject) {
      return inputObject instanceof CanvasFactory;
    }
  }]);
  return CanvasFactory;
}();

exports["default"] = CanvasFactory;